import $ from 'jquery';
import '../scripts/jquery.scrollTo';
import 'jquery-inview';
import 'lazysizes';
import touchScroll from './touchScroll';
import throttle from './throttle';

$(function() {
  let $fundLogosTopOffset;

  const $nav = $('#navigation_bar');
  const $fundLogos = $('#fund_logos');

  if ($fundLogos.length) {
    $fundLogosTopOffset = $fundLogos.offset().top;
  }

  const $window = $(window);
  const $bodyTag = $('body');
  const $dropdownTrigger = $('#signin_button');
  const $dropdown = $('#signin_list');
  const $navigationList = $('#navigation_list');

  const $modalCloseElements = $('[data-close=modal]');
  const $videoModal = $('#video_modal');

  const stickNav = function() {
    $nav.addClass('is-sticky');
    return window.setTimeout(() => $nav.addClass('transitioned'), 100);
  };
  const unstickNav = () => $nav.removeClass('is-sticky transitioned');

  const checkNavPosition = throttle(function() {
    if ($window.scrollTop() > $fundLogosTopOffset) {
      return stickNav();
    } else {
      return unstickNav();
    }
  }, 400);

  const throttledCheck = () => checkNavPosition();

  $window.on('scroll', throttledCheck);

  $('[data-nav]').on('click', function(event) {
    const targetEl = $(`#${$(event.target).data('nav')}`);
    disableDrawerNav();
    return $.scrollTo(targetEl, 800);
  });

  const lazySizesConfig = {
    addClasses: true,
    preloadAfterLoad: true
  };

  if (window.matchMedia('(max-width: 480px)').matches) {
    window.lazySizesConfig.expand = 800;
  } else if (window.matchMedia('(max-width: 1024px)').matches) {
    window.lazySizesConfig.expand = 800;
  } else {
    window.lazySizesConfig.expand = 800;
  }

  $('.lazypreload').one('inview', function() {
    return $(this).addClass('inView');
  });

  const hideModal = function() {
    const $modalEl = $('.modal:visible');
    $modalEl.parent().removeClass('is-visible');
    $modalEl.removeClass('is-visible');
    $modalEl.find('.modal-content').removeClass('is-visible');
    $bodyTag.removeClass('modal-active');
    $modalCloseElements.off('click');

    // Close video if available
    const $video = $modalEl.find('#sz_video');

    if ($video.length) {
      return $video.attr('src', '');
    }
  };

  const showModal = function($modalEl, iframeSrc) {
    // THIS CHECK DISABLES MODAL FOR MOBILE / TABLET
    if (window.matchMedia('(max-width:991px)').matches) return;

    $modalEl.parent().addClass('is-visible');
    $modalEl.addClass('is-visible');
    $modalEl.find('.modal-content').addClass('is-visible');
    $bodyTag.addClass('modal-active');
    const $iframe = $modalEl.find('iframe');
    if ($iframe.length) {
      return $iframe.attr('src', iframeSrc);
    }
  };

  const displayModal = function(event) {
    const $target = $(event.target);

    // Pop up modal
    event.preventDefault();
    let $targetModal = $(`#${$target.data('modal')}`);
    showModal($targetModal, $target.data('iframesrc'));
    return $modalCloseElements.on('click', hideModal);
  };

  $('[data-modal]').on('click', displayModal);

  const enableDrawerNav = function() {
    touchScroll.disableScroll();
    let scrollPos = $window.scrollTop();
    $navigationList.addClass('is-active').css('top', scrollPos);
    return $bodyTag.addClass('is-navState');
  };

  var disableDrawerNav = function() {
    touchScroll.enableScroll();
    $navigationList.removeClass('is-active');
    return $bodyTag.removeClass('is-navState');
  };

  $('.modal').click(event => event.stopPropagation());

  $dropdownTrigger.click(function(event) {
    event.preventDefault();
    event.stopPropagation();
    $dropdownTrigger.addClass('is-active');
    return $dropdown.show();
  });

  $dropdown.click(event => event.stopPropagation());
  $('html').click(function(event) {
    $dropdownTrigger.removeClass('is-active');
    $navigationList.removeClass('is-active');
    return $dropdown.hide();
  });

  $('main').click(function(event) {
    if ($bodyTag.hasClass('is-navState')) {
      return disableDrawerNav();
    }
  });

  $('#mobile_nav_toggle').on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    $('#nav_signup_button').removeClass('navigation-button');
    if ($bodyTag.hasClass('is-navState')) {
      return disableDrawerNav();
    } else {
      return enableDrawerNav();
    }
  });

  $navigationList.click(event => event.stopPropagation());

  $('[data-modal-promo-button]').click(function(event) {
    event.preventDefault();
    hideModal();
    localStorage.setItem('fbReport-PromoViewed', 'true');
    if ($(this).data('modalPromoButton') === 'confirm') {
      return $('#join-sumzero-hidden-button').click();
    }
  });

  const $modalA = $('#promo_modal_A');
  const $modalB = $('#promo_modal_B');

  const maybeShowProductModal = function() {
    if (window.location.hash === '#products') {
      return $('#join-sumzero-hidden-button').click();
    } else if (!window.localStorage.getItem('fbReport-PromoViewed')) {
      return true;
      // const modals = {
      //   a: {
      //     active: true,
      //     name: 'Modal A - Facebook Report',
      //     modal: $modalA
      //   },
      //   b: {
      //     active: false,
      //     name: 'Modal B - Image of 2017 Comp Report',
      //     modal: $modalB
      //   }
      // }
      // const modalKeys = Object.keys(modals).filter(key => modals[key].active);
      // const randomlySelectedModal = modals[modalKeys[Math.floor(Math.random() * modalKeys.length)]];
      // heap.track('Homepage Promo Modal Loaded', {type: randomlySelectedModal.name});
      // showModal(randomlySelectedModal.modal);
      // return $modalCloseElements.on('click', hideModal);
    }
  };

  $window.on('hashchange', maybeShowProductModal);

  return maybeShowProductModal();
});
